import React__default, { useState } from 'react';
import ImageAdapter from '../../Image/Image.js';
import { Text } from '../../Text/Text.js';
import { useWindowSize } from '@breville/xps-utils/core/useWindowSize';
import { BREAKPOINT_MD } from '@breville/xps-utils/core/constants';

// import { Button } from 'core-ts/Button';
const SwatchPicker = (props) => {
    const { swatches, variant = 'vertical', t = (key, options) => (typeof options === 'string' ? options : ((options === null || options === void 0 ? void 0 : options.defaultValue) || key)) } = props, length = 3, totalLength = swatches.length, currentSwatch = swatches[0] || '';
    // TODO: Swatch length should be configurable
    const [initialSwatches, setInitialSwatches] = useState(swatches === null || swatches === void 0 ? void 0 : swatches.slice(0, length));
    const windowSize = useWindowSize();
    const isMobile = windowSize.width < BREAKPOINT_MD;
    function handleMore() {
        setInitialSwatches(swatches);
    }
    switch (variant) {
        // Horizontal not supported atm;
        case 'vertical':
        default:
            return (React__default.createElement(React__default.Fragment, null, isMobile ? (Array.isArray(initialSwatches) &&
                initialSwatches.length > 0 && (React__default.createElement("div", { className: 'xps-pc-swatch-picker vertical vs-mobile' },
                React__default.createElement(ImageAdapter, { src: currentSwatch.color, className: 'vs-colors', width: 20, height: 20, alt: currentSwatch.name }),
                initialSwatches.length > 1 && React__default.createElement(Text, { tag: 'p', type: 'p4', className: 'vs-more-text' },
                    totalLength,
                    " ",
                    t('styles', 'Styles'))))) : (React__default.createElement("ul", { className: 'xps-pc-swatch-picker vertical', "data-testid": 'xps-pc-swatch-picker-vertical' }, initialSwatches === null || initialSwatches === void 0 ? void 0 :
                initialSwatches.map((swatch, idx) => (React__default.createElement("li", { className: 'vs-color-lists', key: idx },
                    React__default.createElement(ImageAdapter, { src: swatch.color, className: 'vs-colors', width: 20, height: 20, alt: swatch.name })))),
                React__default.createElement("li", { className: 'vs-more' }, (swatches === null || swatches === void 0 ? void 0 : swatches.length) >= length &&
                    totalLength !== initialSwatches.length && (React__default.createElement("button", { onClick: handleMore, className: 'vs-more-btn' },
                    React__default.createElement(Text, { tag: 'p', type: 'p4', className: 'vs-more-text' }, t('eh-link-label-more', 'More')))))))));
    }
};

export { SwatchPicker };
//# sourceMappingURL=index.js.map
